import * as React from 'react'
import { BLUE } from '../../colors'

const IconDeactivate = (props) => (
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g transform='translate(0 .5)' fill='none' fillRule='evenodd'>
      <circle stroke={props.color ?? BLUE} strokeWidth={3} cx={12} cy={12} r={10.5} />
      <rect
        fill={props.color ?? BLUE}
        transform='rotate(90 12 12)'
        x={10}
        y={5}
        width={4}
        height={14}
        rx={1}
      />
    </g>
  </svg>
)

export default IconDeactivate
